import { AppBar, Toolbar as MuiToolbar, Toolbar, Button } from "@mui/material";
import { SaveButton, useRecordContext, useRedirect, useResourceContext, useRefresh, useSaveContext } from "react-admin";
import { useNavigate } from "react-router-dom";
import { useFormState } from "react-hook-form";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface FormToolbarProps {
  edit?: boolean;
}

export default function FormToolbar({ edit }: FormToolbarProps) {
  const record = useRecordContext<any>();
  const resource = useResourceContext();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const navigate = useNavigate();
  const saveContext = useSaveContext();
  const { isSubmitting } = useFormState();

  const isSaving = Boolean(isSubmitting || saveContext?.saving);
  const isReadOnly = record && (record.closed === true || record.rejected === true || record.annulled === true);

  const handleBack = () => {
    refresh();
    if (resource) {
      redirect(`/${resource}`);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <AppBar position="fixed" sx={{ top: "auto", bottom: 0, zIndex: 1100 }}>
          <Toolbar sx={{ display: "flex", justifyContent: isReadOnly ? "flex-start" : "space-between", paddingLeft: "10px", paddingRight: "10px" }}>
            <Button
              variant="contained"
              color="inherit"
              disabled={isSaving}
              startIcon={<ArrowBackIcon />}
              onClick={handleBack}
              sx={{ bgcolor: '#ffffff', color: '#1976d2', fontWeight: 'bold', '&:hover': { bgcolor: '#e3f2fd' } }}
            >
              Volver al listado
            </Button>
            {!isReadOnly && (
              <SaveButton
                type="button"
                alwaysEnable={!isSaving}
                disabled={isSaving}
                label={isSaving ? "Guardando..." : "ra.action.save"}
                transform={data => ({ ...record, ...data })}
              />
            )}
          </Toolbar>
      </AppBar>
      <MuiToolbar />
    </>
  );
}
